import type { Alert, AlertsMeta } from "../types/alerts";
import AlertCard from "./AlertCard";
import StaleBadge from "./StaleBadge";

interface Props {
  alerts: Alert[];
  meta?: AlertsMeta;
  isError?: boolean;
  ariaLabel?: string;
}

export default function AlertsSection({
  alerts,
  meta,
  isError,
  ariaLabel = "Weather alerts",
}: Props) {
  if (isError) {
    return (
      <p role="status" className="py-2 text-body-medium text-on-surface-variant">
        Alerts unavailable right now
      </p>
    );
  }

  if (alerts.length === 0) {
    return null;
  }

  return (
    <section aria-label={ariaLabel} className="flex flex-col gap-2 pb-4">
      {meta?.stale ? <StaleBadge generatedAt={meta.generatedAt} /> : null}
      <ul className="flex flex-col gap-2">
        {alerts.map((a) => (
          <AlertCard key={a.id} alert={a} />
        ))}
      </ul>
    </section>
  );
}
